import { render, staticRenderFns } from "./DetailTableRequestTicket.vue?vue&type=template&id=28995c7e&"
import script from "./DetailTableRequestTicket.vue?vue&type=script&lang=ts&"
export * from "./DetailTableRequestTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports